import { z } from "zod";

import { deliverableTypeSchema, expressionTypeSchema } from "./enums";
import { conditionalSchema } from "./conditional";
import { assignmentExpressionSchema } from "./assignment-expression";
import { rotationParametersSchema } from "./rotation-parameters";
import { printVariableInfoSchema } from "./print-variable";
import { cubeOptionsSchema } from "./cube-configuration";
import { addCartonConfigurationSchema } from "./add-carton-configuration";
import {
	splitStringByCharacterCountConfigurationSchema,
	splitStringByDelimiterConfigurationSchema,
} from "./split-string-configuration";
import { addLabelConfigurationSchema } from "./add-label-configuration";
import { addPrintImageConfigurationSchema } from "./add-print-image-configuration";
import { setLabelPositionConfigurationSchema } from "./set-label-position-configuration";
import { roundValueConfigurationSchema } from "./round-value-configuration";
import { padStringConfigurationSchema } from "./pad-string-configuration";
import { joinStringsConfigurationSchema } from "./join-strings-configuration";
import { sortDimensionsConfigurationSchema } from "./sort-dimensions-configuration";
import { updateCartonDesignConfigurationSchema } from "./update-carton-design-configuration";
import { extractValueConfigurationSchema } from "./extract-value-configuration";
import { convertDatetimeConfigurationSchema } from "./convert-datetime-configuration";
import { ignoreDuplicateWorkConfigurationSchema } from "./ignore-duplicate-work-configuration";
import { scalePrimaryCartonConfigurationSchema } from "./scale-primary-carton-configuration";
import { addClosingConfigurationSchema } from "./add-closing-configuration";
import { generateRandomValueConfigurationSchema } from "./generate-random-value-configuration";

export const ruleActionConfigurationSchema = z.object({
	context: deliverableTypeSchema.optional(),
	conditional: conditionalSchema.optional(),
	target: z.string().optional(),
	firstValue: z.string().optional(),
	secondValue: z.string().optional(),
	valueExpression: z.string().optional(),
	expressionType: expressionTypeSchema.optional(),
	assignmentExpressions: z.array(assignmentExpressionSchema).nullish(),
	designId: z.string().optional(),
	optimalRotation: z.boolean().optional(),
	rotationParameters: rotationParametersSchema.optional(),
	quality: z.string().optional(),
	thickness: z.string().optional(),
	length: z.string().optional(),
	width: z.string().optional(),
	height: z.string().optional(),
	xValues: z.array(z.string()).optional(),
	templateName: z.string().optional(),
	printVariables: z.array(printVariableInfoSchema).optional(),
	cubeOptions: cubeOptionsSchema.optional(),
	addCartonConfiguration: addCartonConfigurationSchema.optional(),
	splitStringByCharacterCountConfiguration: splitStringByCharacterCountConfigurationSchema.optional(),
	splitStringByDelimiterConfiguration: splitStringByDelimiterConfigurationSchema.optional(),
	addStandaloneLabelConfiguration: addLabelConfigurationSchema.optional(),
	addPrintImageConfiguration: addPrintImageConfigurationSchema.optional(),
	targetField: z.string().optional(),
	setLabelPositionConfiguration: setLabelPositionConfigurationSchema.optional(),
	roundValueConfiguration: roundValueConfigurationSchema.optional(),
	padStringConfiguration: padStringConfigurationSchema.optional(),
	joinStringsConfiguration: joinStringsConfigurationSchema.optional(),
	sortDimensionsConfiguration: sortDimensionsConfigurationSchema.optional(),
	updateCartonDesignConfiguration: updateCartonDesignConfigurationSchema.optional(),
	extractValueConfiguration: extractValueConfigurationSchema.optional(),
	convertDatetimeConfiguration: convertDatetimeConfigurationSchema.optional(),
	ignoreDuplicateWorkConfiguration: ignoreDuplicateWorkConfigurationSchema.optional(),
	scalePrimaryCartonConfiguration: scalePrimaryCartonConfigurationSchema.optional(),
	addClosingConfiguration: addClosingConfigurationSchema.optional(),
	generateRandomValueConfiguration: generateRandomValueConfigurationSchema.optional(),
});
export type RuleActionConfiguration = z.infer<typeof ruleActionConfigurationSchema>;
